/* Inspired on react-swipe-button but needed to adapt it as it had embedded styling. */
import { ReactNode, useState } from 'react';
import styled from 'styled-components';
import { motion, useMotionValue, useTransform } from 'motion/react';
import breakpoint from '~/utils/style-utils';

type SwiperProps = {
	iconWidth: number;
	containerWidth: number;
	buttonIcon?: ReactNode;
	confirmIcon?: ReactNode;
	dataAt?: string;
	onConfirm?: () => void;
};

const StyledSliderButton = styled(motion.div)<{ iconWidth: number }>`
	width: ${props => `${props.iconWidth}px`};
	min-width: 74px;
	height: 40px;
	background-color: rgba(var(--info), 1);
	border-radius: var(--base-radius-rounded);
	display: flex;
	justify-content: center;
	position: absolute;
	stroke-width: 0.1px;
	cursor: pointer;
	${breakpoint.lg`
		min-width: 40px;
		justify-content: right;
	`}
`;

const SwiperBar = styled(motion.div)`
	height: 40px;
	position: absolute;
	background-color: rgba(var(--info), 1);
	border-radius: var(--base-radius-rounded);
`;

const SwipeWrapper = styled.span`
	background-color: rgba(var(--primary-accent-blue), 1);
	border-radius: var(--base-radius-rounded);
	width: 100%;
	${breakpoint.lg`
		width: 80px;
		height: 40px;
	`}
`;

const StyledIcon = styled.div`
	padding: 11px;
	${breakpoint.lg`
		float: right;
		padding: 8px;
	`}
`;

const Swiper = ({ buttonIcon, confirmIcon, onConfirm, iconWidth, containerWidth, dataAt }: SwiperProps) => {
	const x = useMotionValue(0);
	const [confirmed, setConfirmed] = useState(false);
	const width = useTransform(x, [0, containerWidth - iconWidth], [iconWidth, containerWidth]);

	return (
		<SwipeWrapper>
			<SwiperBar style={{ width, top: '50%', translateY: '-50%' }} />
			<StyledSliderButton
				iconWidth={iconWidth}
				drag="x"
				dragElastic={0}
				dragMomentum={false}
				dragConstraints={{ left: 0, right: containerWidth - iconWidth }}
				style={{ top: '50%', translateY: '-50%', width }}
				_dragX={x}
				onDragEnd={() => {
					if (x.get() > (containerWidth - iconWidth) * 0.9) {
						if (onConfirm) {
							setConfirmed(true);
							onConfirm();
						}
					} else {
						x.set(0);
					}
				}}
				data-at={dataAt}
			>
				<StyledIcon>{confirmed ? confirmIcon : buttonIcon}</StyledIcon>
			</StyledSliderButton>
		</SwipeWrapper>
	);
};

export default Swiper;
